import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-linkedin',
  shadow: false,
})
export class CmsIconLinkedin {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {
    return (
      /*@ts-ignore*/
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 20 20"
        focusable="false"
        aria-hidden="true"
        fill-rule="evenodd"
        clip-rule="evenodd"
        width={this.dataWidth}
        height={this.dataHeight}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.25 1.25H2.24609C1.55859 1.25 1 1.81641 1 2.51172V17.4883C1 18.1836 1.55859 18.75 2.24609 18.75H17.25C17.9375 18.75 18.5 18.1836 18.5 17.4883V2.51172C18.5 1.81641 17.9375 1.25 17.25 1.25ZM6.28906 16.25H3.69531V7.89844H6.29297V16.25H6.28906ZM4.99219 6.75781C4.16016 6.75781 3.48828 6.08203 3.48828 5.25391C3.48828 4.42578 4.16016 3.75 4.99219 3.75C5.82031 3.75 6.49609 4.42578 6.49609 5.25391C6.49609 6.08594 5.82422 6.75781 4.99219 6.75781V6.75781ZM16.0117 16.25H13.418V12.1875C13.418 11.2188 13.3984 9.97266 12.0703 9.97266C10.7187 9.97266 10.5117 11.0273 10.5117 12.1172V16.25H7.91797V7.89844H10.4063V9.03906H10.4414C10.7891 8.38281 11.6367 7.69141 12.8984 7.69141C15.5234 7.69141 16.0117 9.42187 16.0117 11.6719V16.25V16.25Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
